// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "An embed tool to display single or a series of datawrapper charts with a customised menu label feature.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Datawrapper embed v2.0",
  id: "datawrapper-embed",
  groupsWithAccess: ["specialist_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable", "Data viz"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/datawrapper-embed/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "DatawrapperEmbedConfigTool" */ "app/components/tools/DatawrapperEmbedConfigTool/DatawrapperEmbedConfigTool"),
    loading: DynamicImportLoader,
    modules: ["DatawrapperEmbedConfigTool"]
  })
};

export default CONFIG;
